// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8a2b299f","455":"ce821cdd","977":"cf71eb9c"}[chunkId] + ".chunk.js";
};